import { City, CityGroup } from '../types'
import { Close as CloseIcon } from '@mui/icons-material'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from '@mui/material'

interface CityGroupInfoDialogProps {
  readonly group: CityGroup | null
  readonly cities: City[]
  readonly onClose: () => void
}

export function CityGroupInfoDialog({
  group,
  cities,
  onClose,
}: CityGroupInfoDialogProps) {
  if (!group) return null

  return (
    <Dialog
      open={Boolean(group)}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { bgcolor: '#31353D', backgroundImage: 'none' } }}
    >
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Box>
            <Typography variant="h6">{group.name}</Typography>
            <Typography variant="body2" color="text.secondary">
              {group.description}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>City</TableCell>
                <TableCell>Province/State</TableCell>
                <TableCell>Country</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {group.cities.map((cityId) => {
                const city = cities.find((c) => c.id === cityId)
                if (!city) return null
                return (
                  <TableRow key={cityId} hover>
                    <TableCell>{city.name}</TableCell>
                    <TableCell>
                      <Typography variant="body2" color="text.secondary">
                        {city.state}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color="text.secondary">
                        {city.country}
                      </Typography>
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  )
}
